var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colored-letter-square",style:({backgroundColor: _vm.bgcolor})},[_vm._v("\n    "+_vm._s(_vm.initials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }